<template>
  <sui-page>
    <sui-page-header :pageId="contextPageId" />
    <sui-page-contents>
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_TITLE')"
              :required="true"
            />
          </div>
          <div class="col-xs-11">
            <div class="comm_label">
              {{ objEmail.emailTitle }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_SEND_USR')"
              :required="true"
            />
          </div>
          <div class="col-xs-11">
            <div class="comm_label">
              {{ objEmail.sendUserName }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_RCPT_USR')"
              :required="true"
            />
          </div>
          <div class="col-xs-11">
            <div class="comm_label">
              {{ receiptUserSet }}
              <sui-button
                type="button"
                class="btn_innerTbl_border"
                @click="onClickRecpPopup"
              >
                {{ $t('MSG_BTN_ALL_VIEW') }}
              </sui-button>
            </div>
          </div>
        </div>
      </div>
      <div class="mrB30" />
      <cmp-file-attacher
        v-if="attachFileYn"
        ref="fileAttacher"
        width="700px"
        :pageId="contextPageId"
        :showAddDeleteBtn="false"
        :showUpDownArrowBtn="false"
        :attachGroupId="attachGroupId"
        :attachDocumentId="objEmail.attachDocumentId"
      />
      <div class="mrB30" />
      <sui-web-editor
        ref="tuiEditor"
        :isViewer="isEditorViewerMode"
        class="width100"
        @loaded="loadEmailInfo"
      />
      <div class="mrB15" />
      <div
        v-if="receiveType"
        class="comm_btnBot_wrap"
      >
        <div class="btn_wrapL">
          <sui-button
            type="button"
            class="comm_btn_border"
            @click="onListClick"
          >
            {{ $t("MSG_BTN_LIST") }}
          </sui-button>
        </div>
        <div class="btn_wrapR">
          <sui-button
            v-permission:print="contextPageId"
            type="button"
            class="comm_btn_border"
            @click="onPrintClick"
          >
            {{ $t("MSG_BTN_PRTG") }}
          </sui-button>
          <sui-button
            v-permission:delete="contextPageId"
            type="button"
            class="comm_btn_solid"
            @click="onDeleteClick"
          >
            {{ $t("MSG_BTN_DEL") }}
          </sui-button>
          <sui-button
            v-permission:create="contextPageId"
            type="button"
            class="comm_btn_solid"
            @click="onTransferClick"
          >
            {{ $t("MSG_BTN_TRMS") }}
          </sui-button>
          <sui-button
            v-permission:create="contextPageId"
            type="button"
            class="comm_btn_solid"
            @click="onReplyClick"
          >
            {{ $t("MSG_BTN_REPLY") }}
          </sui-button>
        </div>
      </div>
      <div
        v-if="sendType"
        class="comm_btnBot_wrap"
      >
        <div class="btn_wrapL">
          <sui-button
            type="button"
            class="comm_btn_border"
            @click="onListClick"
          >
            {{ $t("MSG_BTN_LIST") }}
          </sui-button>
        </div>
        <div class="btn_wrapR">
          <sui-button
            v-permission:print="contextPageId"
            type="button"
            class="comm_btn_border"
            @click="onPrintClick"
          >
            {{ $t("MSG_BTN_PRTG") }}
          </sui-button>
          <sui-button
            v-permission:delete="contextPageId"
            type="button"
            class="comm_btn_solid"
            @click="onDeleteClick"
          >
            {{ $t("MSG_BTN_DEL") }}
          </sui-button>
          <sui-button
            v-permission:create="contextPageId"
            type="button"
            class="comm_btn_solid"
            @click="onTransferClick"
          >
            {{ $t("MSG_BTN_TRMS") }}
          </sui-button>
          
        </div>
      </div>
      <sui-popup
        v-model="isShownPopupDetail"
        :title="$t('MSG_TIT_RCPT_USR_SRCH')"
      >
        <p01
          :pageId="contextPageId"
          :emailUid="objEmail.emailUid"
          :searchEmailType="searchEmailType"
          :emailReceiptUserIdYn="emailReceiptUserIdYn"
          @close="popDetailClose()"
        />
      </sui-popup>
    </sui-page-contents>
  </sui-page>
</template>

<script>
import BasePage from '~cm/components/BasePage';

import p01 from './components/PGE_CMM_00005_P01';
/* eslint max-len: ["error", { "code" : 500 }] */
export default {
  name: 'PGE_CMM_00005', // eslint-disable-line vue/name-property-casing
  components: {
    p01,
  },
  extends: BasePage,
  data() {
    return {
      isShownPopupDetail: false,
      searchData: {},
      searchEmailType: '',
      emailReceiptUserIdYn: '',
      readFlag: '',
      isTitleBold: '',
      attachGroupId: 'ATG_CMM_MAIL_COMMON',
      isEditorViewerMode: true,
      objEmail: {
        emailUid: '',
        connectionEmailId: '',
        emailTypeCode: '',
        emailTitle: '',
        sendTemplateId: '',
        emailContent: '',
        sendUserEmail: '',
        emailSendStateCode: '',
        attachDocumentId: '',
        batchJobStateCode: '',
        batchJobRETRYNumberOf: '',
        emailReservationYn: '',
        emailStartDTM: '',
        sendUserName: '',
        emailReceiptUserId: '',
        emailReceiptUserName: '',
        emailReceiptUserCount: '',
      },
      receiptUserSet: '',
      receiptUserTypeCode: '',
      // objReceiptUserInfo: [],
      receiptUserTypeYn: '',
    };
  },
  computed: {
    receiveType() {
      return utils.isEqual(utils.getParameter(this, 'searchEmailType'), 'RECEIVE');
    },
    sendType() {
      return utils.isEqual(utils.getParameter(this, 'searchEmailType'), 'SEND');
    },
    attachFileYn() {
      return utils.isEqual(utils.getParameter(this, 'attachFileYn'), 'Y');
    },
  },
  watch: {},
  created() {
    this.customOptions = {
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.onLoad();
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    onLoad() {
      this.searchData = utils.getParameter(this, 'searchData');
      this.searchEmailType = utils.getParameter(this, 'searchEmailType');
      this.readFlag = utils.getParameter(this, 'readFlag');
      this.isTitleBold = utils.getParameter(this, 'isTitleBold');
      this.emailReceiptUserIdYn = utils.getParameter(this, 'emailReceiptUserIdYn');
      this.loadEmailInfo();
    },
    onDeleteClick() {
      const emailUidList = [];
      emailUidList.push({
        emailUid: utils.getParameter(this, 'emailUid'),
        searchEmailType: this.searchEmailType,
      });
      utils.messageBox('confirm', this.$t('MSG_ALT_WANT_DEL'), null, () => {
        http.request(this.contextPageId, 'DTS_CMM_00002', {
          data: emailUidList,
        }).then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_DEL_DATA'), null, this.onListClick());
        }).catch(error => {
          console.log(error);
        });
      });
    },
    onListClick() {
      const goList = this.searchEmailType === 'RECEIVE' ? 'PGE_CMM_00001' : 'PGE_CMM_00002';
      utils.goPage(goList, {
        searchData: this.searchData,
      });
    },
    loadEmailInfo() {
      const emailUid = utils.getParameter(this, 'emailUid');
      const dataParams = {
        searchEmailType: this.searchEmailType,
        emailReceiptUserIdYn: this.emailReceiptUserIdYn,
      };

      if (!utils.isEmpty(emailUid)) {
        // http.requestTest('get', `/api/v1/common/email/${email-uid}`, {
        http.request(this.contextPageId, 'DTS_CMM_00004', {
          path: {
            'email-uid': emailUid,
          },
          query: dataParams,
        }).then(res => {
          this.objEmail.emailUid = res.data[0].emailUid;
          this.objEmail.emailTitle = res.data[0].emailTitle;
          this.objEmail.sendUserName = res.data[0].sendUserName;
          this.objEmail.attachDocumentId = res.data[0].attachDocumentId;
          this.objEmail.emailContent = res.data[0].emailContent;
          this.$refs.tuiEditor.setHtml(res.data[0].emailContent);
          this.objEmail.emailReceiptUserName = res.data[0].emailReceiptUserName;

          let recpUsrCnt = parseInt(res.data[0].emailReceiptUserCount, 0);

          utils.forEach(res.data, data => {
            if (data.emailReceiptUserTypeCode !== 'BCC' || this.emailReceiptUserIdYn === 'Y') {
              if (data.emailReceiptUserId !== this.$store.getters.userInfo.userId && data.emailReceiptUserTypeCode === 'BCC') {
                recpUsrCnt = recpUsrCnt - 1;
              }
              this.objEmail.emailReceiptUserTypeCode = data.emailReceiptUserTypeCode;
              this.receiptUserSet = recpUsrCnt > 0
                ? utils.strFormat(this.$t('MSG_TXT_RECP_CNT'), this.objEmail.emailReceiptUserName, recpUsrCnt)
                : this.objEmail.emailReceiptUserName;
            }
            // this.objReceiptUserInfo.push({
            //   userId: data.emailReceiptUserId,
            //   userTypeCode: data.emailReceiptUserTypeCode,
            // });
          });
        });

        // 이메일 수신상태코드 변경
        if (this.isTitleBold === 'N') {
          return;
        }
        if (this.searchEmailType === 'RECEIVE' && this.readFlag === 'Y') {
          const emailUidList = [];
          emailUidList.push({
            emailUid,
            searchEmailType: 'RECEIVE',
            readFlag: 'Y',
            emailReceiptUserId: this.$store.getters.userInfo.userId,
          });
          http.request(this.contextPageId, 'DTS_CMM_00008', {
            data: emailUidList,
          });
        }
      }
    },
    onTransferClick() {
      const mailList = [];
      const emailUid = utils.getParameter(this, 'emailUid');
      const dataParams = {
        searchReceiptType: 'T',
      };

      http.request(this.contextPageId, 'DTS_CMM_00005', {
        path: {
          'email-uid': emailUid,
        },
        query: dataParams,
      }).then(res => {
        utils.forEach(res.data, (itm, index) => {
          if (itm.emailReceiptUserTypeCode === 'TO') {
            this.receiptUserTypeCode = '1';
          } else if (itm.emailReceiptUserTypeCode === 'CC') {
            this.receiptUserTypeCode = '2';
          } else {
            this.receiptUserTypeCode = '3';
          }

          utils.findIndex(res.data, item => {
            if (item.emailReceiptUserId === this.$store.getters.userInfo.userId && item.emailReceiptUserTypeCode === 'BCC') {
              this.receiptUserTypeYn = 'Y';
            } else {
              this.receiptUserTypeYn = 'N';
            }
            console.log('receiptUserTypeYn:', this.receiptUserTypeYn);
          });

          mailList.push({
            email: itm.receiptUserEmail,
            companyCode: itm.companyCode,
            companyName: itm.companyName,
            departmentId: itm.departmentId,
            departmentName: itm.departmentName,
            epId: itm.epId,
            userId: itm.emailReceiptUserId,
            epNo: itm.epNo,
            irsdSttCd: itm.irsdSttCd,
            knoxId: itm.knoxId,
            userName: itm.emailReceiptUserName,
            usrRealUseYn: itm.usrRealUseYn,
            recipientUserTypeCode: itm.emailReceiptUserTypeCode,
            recipientType: this.receiptUserTypeCode,
            recipient: itm.recipient,
            disFlag: 'true',
            emailSendStatusCode: '',
          });

          if (this.searchEmailType === 'RECEIVE') {
            const itemFind = utils.findIndex(mailList, a => utils.isEqual(a.recipientUserTypeCode, 'BCC'));
            if (itemFind > -1) {
              mailList.splice(itemFind, 1);
            }
          }
        });

        if (this.searchEmailType === 'RECEIVE' && this.receiptUserTypeYn === 'Y') {
          utils.messageBox('confirm', this.$t('MSG_ALT_SEND_EMAIL_BCC'), null, () => {
            utils.openLayerPopup('PGE_CMM_00004',
              this.onClosePagePopup,
              {
                pageInitialData: {
                  attachDocumentId: this.objEmail.attachDocumentId,
                  moduleCode: 'CM',
                  objTemplate: '',
                  mailList,
                  mailTitle: `FW: ${this.objEmail.emailTitle}`,
                  mailContents: `<br /><br />--------- Original Message ---------${this.objEmail.emailContent}`,
                  receiverModify: true,
                  Editor: 'Y',
                },
                size: 'xlg',
              });
          });
        } else {
          utils.openLayerPopup('PGE_CMM_00004',
            this.onClosePagePopup,
            {
              pageInitialData: {
                attachDocumentId: this.objEmail.attachDocumentId,
                moduleCode: 'CM',
                objTemplate: '',
                mailList,
                mailTitle: `FW: ${this.objEmail.emailTitle}`,
                mailContents: `<br /><br />--------- Original Message ---------${this.objEmail.emailContent}`,
                receiverModify: true,
                Editor: 'Y',
              },
              size: 'xlg',
            });
        }
      }).catch(error => {
        console.log(error);
      });
    },
    onReplyClick() {
      const mailList = [];
      const emailUid = utils.getParameter(this, 'emailUid');
      const dataParams = {
        searchReceiptType: 'R',
      };
      http.request(this.contextPageId, 'DTS_CMM_00005', {
        path: {
          'email-uid': emailUid,
        },
        query: dataParams,
      }).then(res => {
        utils.forEach(res.data, data => {
          if (data.emailReceiptUserTypeCode === 'TO') {
            this.receiptUserTypeCode = '1';
          } else if (data.emailReceiptUserTypeCode === 'CC') {
            this.receiptUserTypeCode = '2';
          } else {
            this.receiptUserTypeCode = '3';
          }

          utils.findIndex(res.data, item => {
            if (item.emailReceiptUserId === this.$store.getters.userInfo.userId && item.emailReceiptUserTypeCode === 'BCC') {
              this.receiptUserTypeYn = 'Y';
            } else {
              this.receiptUserTypeYn = 'N';
            }
            console.log('receiptUserTypeYn:', this.receiptUserTypeYn);
          });

          mailList.push({
            email: data.receiptUserEmail,
            companyCode: data.companyCode,
            companyName: data.companyName,
            departmentId: data.departmentId,
            departmentName: data.departmentName,
            epId: data.epId,
            userId: data.emailReceiptUserId,
            epNo: data.epNo,
            irsdSttCd: data.irsdSttCd,
            knoxId: data.knoxId,
            userName: data.emailReceiptUserName,
            usrRealUseYn: data.usrRealUseYn,
            recipientUserTypeCode: data.emailReceiptUserTypeCode,
            recipientType: this.receiptUserTypeCode,
            recipient: data.recipient,
            disFlag: 'true',
            emailSendStatusCode: '',
          });

          if (this.searchEmailType === 'RECEIVE') {
            const itemFind = utils.findIndex(mailList, a => utils.isEqual(a.recipientUserTypeCode, 'BCC'));
            if (itemFind > -1) {
              mailList.splice(itemFind, 1);
            }
          }
        });

        if (this.searchEmailType === 'RECEIVE' && this.receiptUserTypeYn === 'Y') {
          utils.messageBox('confirm', this.$t('MSG_ALT_SEND_EMAIL_BCC'), null, () => {
            utils.openLayerPopup('PGE_CMM_00004',
              this.onClosePagePopup,
              {
                pageInitialData: {
                  attachDocumentId: this.objEmail.attachDocumentId,
                  moduleCode: 'CM',
                  objTemplate: '',
                  mailList,
                  mailTitle: `RE: ${this.objEmail.emailTitle}`,
                  mailContents: `<br /><br />--------- Original Message ---------${this.objEmail.emailContent}`,
                  receiverModify: true,
                  Editor: 'Y',
                },
                size: 'xlg',
              });
          });
        } else {
          utils.openLayerPopup('PGE_CMM_00004',
            this.onClosePagePopup,
            {
              pageInitialData: {
                attachDocumentId: this.objEmail.attachDocumentId,
                moduleCode: 'CM',
                objTemplate: '',
                mailList,
                mailTitle: `RE: ${this.objEmail.emailTitle}`,
                mailContents: `<br /><br />--------- Original Message ---------${this.objEmail.emailContent}`,
                receiverModify: true,
                Editor: 'Y',
              },
              size: 'xlg',
            });
        }
      }).catch(error => {
        console.log(error);
      });
    },
    onPrintClick() {
      this.openPrintWindow('PGE_CMM_00007', 'emailUid', this.objEmail.emailUid);
    },
    openPrintWindow(pageId, key, value) {
      const queryString = `?${key}=${value}&searchEmailType=RECEIVE`;

      utils.openWindowPopup(pageId, queryString, null, {
        top: 100, left: 300, height: 700, width: 915,
      });
    },
    onClickRecpPopup() {
      this.isShownPopupDetail = !this.isShownPopupDetail;
    },
    popDetailClose() {
      this.isShownPopupDetail = !this.isShownPopupDetail;
    },
  },
};
</script>

<style scoped>
</style>
